/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react'
import { XDivider, useTheme } from '../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useMergeState } from 'irmlib/hooks'
import { Label, MenuButton } from 'irmlib/components/Controls'
// import { templateTypes } from '../../../irmlib/src/common/constants'
// import BoxTable from '../../Controls/BoxTable'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useLocation, Link } from 'react-router-dom'
import { MoreVert } from 'irmlib/icons'
import * as localGdeTransactionLite from '../../../services/firestore/localGdeTransactionsLite'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import { clearBusy, closeGeneralDialog, openGeneralDialog } from 'irmlib/containers'
// import ImageContainer from './MultiImageContainer'
import { useTranslation } from 'react-i18next'
// import MuiDataTable from '../../Controls/MuiDataTable'
import { TextField, Box, LinearProgress, Autocomplete, Tooltip } from '@mui/material'
import { Container, Typography, makeStyles } from '@material-ui/core'
import { userRoleAdmin, userRoleSuperUser } from '../../../common/constants'
// import moment from 'moment'
import { UpdateRefImage, UpdateTemplate, UpdateBox } from './LocalMenuActivities'
import { getUserRole, getUser } from '../../../redux/global'
import { MaterialReactTable } from 'material-react-table'
import ExportCsv from '../../Controls/ExportCsv'
// import SaveIcon from '@material-ui/icons/Save'
import IconButton from '@mui/material/IconButton'
import EditIcon from '@material-ui/icons/Edit'
// import { getUser } from '../../../redux/global'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import * as routePaths from '../../../navigation/routePaths'
import { CancelButton } from '../../../irmlib/src/components/FormControls'
import { LocalShowWmsResponseModal } from '../EdgeAI/LocalWmsResponseModal'
// import { uploadRefImg, getImgFromNats } from '../../../services/nats/localNatsTransactions'
// import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import * as constants from '../../../irmlib/src/common/constants'

import Button from '@mui/material/Button'
// import { wmsCode } from '../../../irmlib/src/common'

const PrimaryLabel = styled('div')`
 cursor: pointer;
`

const useStyles = makeStyles((theme) => ({
  containerGroup: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  ProgressBox: {
    padding: theme.spacing(1),
    borderRadius: 8,
    width: '200px',
    margin: 0,
    border: '1px solid #c9c9c9',
    fontSize: '0.875rem',
    marginRight: '10px',
    textAlign: 'center'
  },
  container: {
    padding: theme.spacing(1),
    borderRadius: 8,
    width: 'fit-content',
    margin: 0,
    border: '1px solid #c9c9c9',
    fontSize: '0.875rem',
    marginRight: '5px',
  },
  progressContainer: {
    marginLeft: '5px',
    display: 'flex',
    height: 'fit-content',
  },
  content: {
    fontSize: '0.875rem',
    lineHeight: 2.5
  },
  contentBox: {
    fontSize: '0.875rem',
    lineHeight: 2
  },
  value: {
    color: '#58595b'
  },
  chipGroup: {
    '& .MuiChip-root': {
      margin: '0 5px',
      borderRadius: '20px',
      fontSize: '14px',
      height: '32px',
    },
  },
  progressBarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  percentage: {
    marginLeft: theme.spacing(1),
  },
  editableInput: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none', // Remove the border
      },
      '&:hover fieldset': {
        border: 'none', // Remove the hover border
      },
      '&.Mui-focused fieldset': {
        border: 'none', // Remove the focused border
      },
    },
    '& .MuiInputBase-input': {
      borderBottom: '2px solid black',
      width: '90%',
      padding: '0', // Adjust padding as needed
      color: 'black', // Initially text color black
    },
    '& .MuiInputBase-input:focus': { // Highlight for editing
      borderBottom: '2px solid blue', // Change underline to blue when editing
      color: 'black', // Change text color to blue when editing
    },
  },

}))

const BoxLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
  text-overflow: clip;
`

const Styles = {
  progressBarStyle: {
    marginTop: '2px',
    marginRight: '5px',
    height: '12px',
    padding: '5px',
    borderRadius: '2px',
    width: '80%',
    backgroundColor: '#E4E4E4',
    '.MuiLinearProgress-bar': {
      backgroundColor: '#005487',
    },
  },
}

const DetailsSubtitle = (props) => {
  return (
    <>
      <PrimaryLabel id={'activityList_button_boxDetails'} onClick={props.onShowBoxList} style={props.boxColor ? { color: '#1975bc' } : { color: '#58595b' }}><Label>routeTitles.boxDetails</Label></PrimaryLabel>
      <XDivider width='10px' />
      |
      <XDivider width='10px' />

      <PrimaryLabel
        id={'acivityList_button_ResponseDetails'}
        onClick={props.onShowResponseList}
        style={props.responseColor ? { color: '#1975bc' } : { color: '#58595b' }}>
        <Label>routeTitles.responseDetails</Label>
      </PrimaryLabel>
    </>
  )
}

DetailsSubtitle.propTypes = {
  onShowBoxList: PropTypes.func,
  onShowResponseList: PropTypes.func,
  boxColor: PropTypes.bool,
  responseColor: PropTypes.bool
}


const initialSate = {
  showTable: false,
  boxes: [],
  jobDoc: '',
  boxUserList: [],
  jobUserData: {},
  isNewBoxDisable: false,
  requestData: {},
  closedCount: 0,
  uploadedCount: 0,
  exceptionCount: 0,
  totalBoxes: 0,
  wmsCode: '',
  oneilBoxesPending: 0,
  oneilBoxesUploaded: 0,
  status: ''
}

const BoxSubList = (props) => {
  const [, setState, getState] = useMergeState(initialSate)
  const location = useLocation()
  const requestId = location.pathname.split('/')[3]
  const { t } = useTranslation()
  // const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  const [isLoading, setIsLoading] = useState(false)
  const [boxesData, setBoxesData] = useState([])
  const theme = useTheme()
  const [openMenuItem, setopenMenuItem] = useState(false)
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [boxReopen, setBoxReopen] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [enableOptions, setEnableOptions] = useState(true)
  // eslint-disable-next-line
  const [wmsCode, setWmsCode] = useState('')
  const isMountedRef = useRef(true)

  // Track component mount status
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    const userRole = getUserRole()
    if (userRole === userRoleAdmin || userRole === userRoleSuperUser) {
      setEnableOptions(true)
    } else {
      setEnableOptions(false)
    }
  }, [])

  useEffect(() => {
    const getRequest = async () => {
      const request = await localGdeTransactionLite.getRequestById(requestId)
      if (isMountedRef.current) {
        setWmsCode(request?.wmsCode)
      }
    }
    getRequest()
  }, [requestId])

  const columnsBox = [
    {
      accessorKey: 'boxId',
      header: t('tableColumns.boxId'),
    },
    {
      accessorKey: 'status',
      header: t('tableColumns.status'),
    },
    {
      accessorKey: 'formatError',
      header: t('tableColumns.format'),
    },
    {
      accessorKey: 'exception',
      header: t('tableColumns.exceptionMsg'),
    },
    {
      accessorKey: 'templateImgCount',
      header: t('tableColumns.imageCount'),
    },
    {
      accessorKey: 'imgProcessCount',
      header: t('tableColumns.processedImg'),
    },
    {
      accessorKey: 'totalFilesCount',
      header: t('tableColumns.totalFiles'),
    },
    {
      accessorKey: 'assetType',
      header: t('tableColumns.assetType'),
    },
    {
      accessorKey: 'lob',
      header: t('templates.lineOfBusiness'),
    },
    {
      accessorKey: 'wmsStatus',
      header: t('tableColumns.wmsStatus'),
    },
    enableOptions && getUser().role === 'SUPER USER'
      ? {
          accessorKey: 'modify',
          header: t('tableColumns.action'),
          Cell: ({ row }) => {
            const rowData = getState()?.boxes[row?.index]
            let customMenuItems = []
            if (!rowData) return null
            if (rowData && rowData?.isReopen) {
              customMenuItems = menuItems2
            } else {
              customMenuItems = menuItems
            }
            return (
              <MenuButton
                id={'allJobs_ellipsis'}
                buttonIcon={<MoreVert />}
                rowdata={rowData}
                items={customMenuItems}
                onSelect={(value) => { onSelect(value, rowData) }}
              />
            )
          },
          enableColumnFilter: false,
        }
      : null
  ].filter(Boolean)

  const flatFileIdColumn = {
    accessorKey: 'flatFileId',
    header: t('tableColumns.fileId'),
    Cell: ({ cell }) => {
      const [copied, setCopied] = useState(false)
      const value = cell.getValue()
      const handleCopy = () => {
        if (value !== '') {
          navigator.clipboard.writeText(value)
          setCopied(true)
          setTimeout(() => setCopied(false), 1000)
        }
      }
      return (
        <Tooltip title={copied ? 'Copied' : 'Click to copy'} arrow placement='top-start'>
          <span onClick={handleCopy}
            style={{ cursor: 'pointer' }}>
            {value}
          </span>
        </Tooltip>
      )
    }
  }

  columnsBox.push(flatFileIdColumn)
  columnsBox.forEach((column) => {
    if (column.accessorKey === 'formatError') {
      // column.header = 'Format Error'
      column.Cell = ({ row }) => {
        const rowdata = row.original
        if (rowdata?.formatError === 'true') {
          return (
            <Button
              onClick={() => props.onHandleFormatError(rowdata)}
              variant="contained"
              color="primary"
              size="small"
              style={{ margin: '0 0 0 4px' }}
            >
              {t('buttons.yes')}
            </Button>
          )
        } else {
          const theme = createTheme({
            components: {
              MuiButton: {
                styleOverrides: {
                  root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&.Mui-disabled': {
                      backgroundColor: '#9e9e9e',
                      color: 'white',     
                    }
                  }
                }
              }
            }
          })
          return (
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                size="small"
                disabled={true}
                style={{ margin: '0 0 0 4px' }}
              >
                {rowdata?.formatError === '-' ? '-' : t('buttons.no')}
              </Button>
            </ThemeProvider>
          )
        }
      }
    }
    if (column.accessorKey === 'boxId') {
      column.Cell = ({ row }) => {
        const rowdata = row?.original
        return (
          <BoxLink theme={theme} to={`${routePaths.localboxImageDetails}/${requestId}/${rowdata?.boxId}/${rowdata.activityId}`}>
            {rowdata?.boxId}
          </BoxLink>
        )
      }
    }
    if (column.accessorKey === 'wmsStatus') {
      column.Cell = ({ row }) => {
        const rowdata = row?.original
        // console.log(rowdata)
        if (rowdata?.wmsStatus === 'Failed') {
          return (
            <>
              <Button
                onClick={() => props.onShowRequestList(rowdata)}
                variant="contained"
                color="primary"
                size="small"
                style={{ margin: '0 0 0 4px', width: '80px' }}
              >
                {rowdata?.wmsStatus}
              </Button>
              {/* <WmsResponseModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              columns={modalColumns}
              data={modalData}
              title={modalTitle}
            /> */}
            </>
          )
        } else {
          return (
            <Button
              variant="contained"
              size="small"
              disabled={true}
              style={{ margin: '0 0 0 4px', width: '80px' }}
            >
              {rowdata?.wmsStatus}
            </Button>
          )
        }
      }
    }    
  })

  // blocked below code for user story :: 1439
  // if (wmsCode === 'SKP') {
  //   const indexOfwmsStatusColumn = columnsBox.findIndex(column => column.accessorKey === 'wmsStatus')
  //   if (indexOfwmsStatusColumn !== -1) {
  //     columnsBox.splice(indexOfwmsStatusColumn, 1)
  //   }
  // }

  // const options = {
  //   filter: false,
  //   // filterType: 'dropdown',
  //   selectableRows: 'none',
  //   download: false,
  //   print: false,
  // }

  const menuItems = [
    { value: 'Reopen Box', id: 'createJobs_edit', label: t('Search.ReopenBox'), style: { color: theme.palette.primary.main } },
    { value: 'Change Reference Image', label: t('Search.ChangeRefImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template', label: t('Search.ChangeTemplate'), style: { color: theme.palette.primary.main } },
  ]

  const menuItems2 = [
    { value: 'Change Reference Image', label: t('Search.ChangeRefImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template', label: t('Search.ChangeTemplate'), style: { color: theme.palette.primary.main } },
  ]

  const handleOpenMenuItems = (rowData) => {
    setSelectedRowData(rowData)
    setopenMenuItem(true)
  }

  const handleCloseMenuItems = () => {
    setopenMenuItem(false)
    setSelectedRowData(null)
  }

  const handleOpenTemplateModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenTemplateModal(true)
  }

  const handleCloseTemplateModal = () => {
    setOpenTemplateModal(false)
    setSelectedRowData(null)
  }

  const handleBoxReopen = (rowData) => {
    setSelectedRowData(rowData)
    setBoxReopen(true)
  }

  const handleCloseBoxReopenModal = () => {
    setBoxReopen(false)
    setSelectedRowData(null)
  }

  const onSelect = (value, rowData) => {
    if (value === 'Change Reference Image') {
      handleOpenMenuItems(rowData)
    }
    if (value === 'Change Template') {
      handleOpenTemplateModal(rowData)
    }
    if (value === 'Reopen Box') {
      handleBoxReopen(rowData)
    }
  }

  useEffect(() => {
    let unsubscribe = null
    
    // Wrap setBoxesData to check mount status
    const safeSetBoxesData = (data) => {
      if (isMountedRef.current) {
        setBoxesData(data)
      }
    }
    
    const setupListener = async () => {
      if (!isMountedRef.current) return
      getBoxesDetails()
      unsubscribe = await localGdeTransactions.boxesListener(safeSetBoxesData, requestId)
    }
    
    setupListener()
    
    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [requestId])

  useEffect(() => {
    if (!isMountedRef.current) return
    getBoxesDetails()
  }, [boxesData])

  const getBoxesDetails = async () => {
    if (!isMountedRef.current) return

    try {
      setIsLoading(true)
      if (boxesData.length === 0) {
        const boxDetails = await localGdeTransactionLite.getSubActivity(requestId)
        const boxes = []

        const imagePromises = new Map()
        const boxDataArray = []

        for (const doc of boxDetails?.docs) {
          const boxData = doc?.data()
          boxDataArray.push({ doc, boxData })

          if (boxData?.imgReference?.includes('nats')) {
            if (!imagePromises.has(boxData.imgReference)) {
              imagePromises.set(
                boxData.imgReference,
                // natsService.getImgFromNats(
                getImgFromNats(
                  constants.LOCAL_NATS_SERVER,
                  constants.LOCAL_AI_REF_IMG,
                  boxData.imgReference
                ).catch(error => {
                  console.error('Error loading image:', boxData.imgReference, error)
                  return null
                })
              )
            }
          }
        }

        const imageResults = new Map()
        if (imagePromises.size > 0) {
          const imageKeys = Array.from(imagePromises.keys())
          const imageValues = await Promise.all(Array.from(imagePromises.values()))
          imageKeys.forEach((key, index) => {
            imageResults.set(key, imageValues[index])
          })
        }

        for (const { doc, boxData } of boxDataArray) {
          const format = boxData?.formatError !== undefined ? boxData?.formatError.toString() : '-'
          const wmsStatusTra = boxData?.wmsStatus !== undefined ? t(`wmsResponseStatusObj.${boxData?.wmsStatus}`) : '-'
          const flatFileIdData = boxData?.flatFileDetails !== undefined ? boxData?.flatFileDetails?.dataFile : '-'

          const natsImg = boxData?.imgReference?.includes('nats')
            ? (imageResults.get(boxData.imgReference) || boxData?.imgReference)
            : boxData?.imgReference

          boxes.push({
            boxId: boxData?.skpBoxNbr,
            // status: boxData?.status,
            status: t(`jobStatusObj.${boxData?.status}`),
            formatError: format,
            exception: boxData?.exceptionNote,
            templateImgCount: boxData?.templateImgCount,
            imgProcessCount: boxData?.imgProcessCount,
            totalFilesCount: boxData?.totalFilesCount,
            assetType: boxData?.assetType,
            lob: boxData?.lob,
            currentImageURL: natsImg || boxData?.imgReference,
            activityId: doc?.id,
            customer: boxData?.accountLevel1,
            isReopen: boxData?.isReopen,
            wmsStatus: wmsStatusTra,
            flatFileId: flatFileIdData
          })
          // })
        }

        setState({ boxes: boxes })
      } else {
        const boxes = []

        const imagePromises = new Map()
        const boxDataArray = []

        for (const doc of boxesData) {
          boxDataArray.push({ doc })

          if (doc?.imgReference?.includes('nats')) {
            if (!imagePromises.has(doc.imgReference)) {
              imagePromises.set(
                doc.imgReference,
                // natsService.getImgFromNats(
                getImgFromNats(
                  constants.LOCAL_NATS_SERVER,
                  constants.LOCAL_AI_REF_IMG,
                  doc.imgReference
                ).catch(error => {
                  console.error('Error loading image:', doc.imgReference, error)
                  return null
                })
              )
            }
          }
        }

        const imageResults = new Map()
        if (imagePromises.size > 0) {
          const imageKeys = Array.from(imagePromises.keys())
          const imageValues = await Promise.all(Array.from(imagePromises.values()))
          imageKeys.forEach((key, index) => {
            imageResults.set(key, imageValues[index])
          })
        }

        for (const { doc } of boxDataArray) {
          const format = doc?.formatError !== undefined ? doc?.formatError.toString() : '-'
          const wmsStatusTra = doc?.wmsStatus !== undefined ? t(`wmsResponseStatusObj.${doc?.wmsStatus}`) : '-'
          const flatFileIdData = doc?.flatFileDetails !== undefined ? doc?.flatFileDetails?.dataFile : '-'

          const natsImg = doc?.imgReference?.includes('nats')
            ? (imageResults.get(doc.imgReference) || doc?.imgReference)
            : doc?.imgReference

          boxes.push({
            boxId: doc?.skpBoxNbr,
            // status: doc?.status,
            status: t(`jobStatusObj.${doc?.status}`),
            formatError: format,
            exception: doc?.exceptionNote,
            templateImgCount: doc?.templateImgCount,
            imgProcessCount: doc?.imgProcessCount,
            totalFilesCount: doc?.totalFilesCount,
            assetType: doc?.assetType,
            lob: doc?.lob,
            currentImageURL: natsImg || doc?.imgReference,
            activityId: doc?.id,
            customer: doc?.accountLevel1,
            isReopen: doc?.isReopen,
            wmsStatus: wmsStatusTra,
            flatFileId: flatFileIdData
          })
          // })
        }

        if (isMountedRef.current) {
          setState({ boxes: boxes })
        }
      }
    } catch (error) {
      console.error('Error fetching boxes:', error)
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false)
      }
    }
  }

  const columnsWithWidths = columnsBox.map((col) => {
    const headerLength = col.header.length
    let minWidth = 0
    if (headerLength < 8) {
      minWidth = headerLength * 8
    } else {
      minWidth = headerLength * 15
    }

    if (col.accessorKey !== 'flatFileId') {
      return {
        ...col,
        minSize: minWidth,
        muiTableHeadCellProps: {
          sx: {
            whiteSpace: 'nowrap',
            wordWrap: 'break-word',
            minWidth: `${minWidth}px`,
            overflow: 'visible',
            color: '#58595B',
            fontWeight: 'bold',
          },
        },
        muiTableBodyCellProps: {
          sx: {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }
        },
      }
    } else {
      return {
        ...col,
        minSize: minWidth,
        muiTableHeadCellProps: {
          sx: {
            whiteSpace: 'nowrap',
            wordWrap: 'break-word',
            minWidth: `${minWidth}px`,
            overflow: 'visible',
            color: '#58595B',
            fontWeight: 'bold',
          },
        },
      }
    }
  })

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.smartCatalogLocalRequest'
      subTitle={<><GoBackSubtitle id={'boxList_goBack'}
      />
        <DetailsSubtitle
          onShowBoxList={props.onShowBoxList}
          onHandleFormatError={props.onHandleFormatError}
          boxColor={props.boxColor} onShowResponseList={props.onShowResponseList} /></>}
    >
      {props?.Header()}
      <XDivider width='18px' />
      <Box boxShadow={2} borderRadius={4}>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '22px' }}>
          <Typography variant="h6" gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
            {t('routeTitles.boxDetails')}
          </Typography></div>
        <MaterialReactTable
          columns={columnsWithWidths}
          data={getState()?.boxes}
          state={{ showSkeletons: isLoading }}
          enableColumnFilters={true}
          enableRowSelection
          enableExport={true}
          enableGlobalFilter
          enableColumnFilter
          enableColumnSorting
          enableGrouping={true}
          enableColumnResizing={true}
          initialState={{
            columnVisibility: { images: true, modify: true },
            density: 'compact'
          }}
          muiTableHeadCellProps={{
            sx: {
              color: '#58595B',
              fontWeight: 'bold',
            },
          }}
          renderTopToolbarCustomActions={({ table, data }) => {
            const isDisabled = !table.getIsSomeRowsSelected()
            const isNoData = getState()?.boxes?.length === 0
            const isNoPageData = getState()?.boxes?.length > 4
            return (
              <ExportCsv
                columns={columnsBox}
                isDisabled={isDisabled}
                isNoData={isNoData}
                isNoPageData={isNoPageData}
                table={table}
              />
            )
          }}
          tableFor={'smart_catalog'}
        /></Box>
      {openMenuItem && <UpdateRefImage rowData={selectedRowData} onClose={handleCloseMenuItems} />}
      {openTemplateModal && <UpdateTemplate rowData={selectedRowData} onClose={handleCloseTemplateModal} />}
      {boxReopen && <UpdateBox rowData={selectedRowData} onClose={handleCloseBoxReopenModal} />}
    </MainRouteSubRoutePage>
  )
}

BoxSubList.propTypes = {
  onShowBoxList: PropTypes.func,
  onHandleFormatError: PropTypes.any,
  onShowResponseList: PropTypes.func,
  boxColor: PropTypes.bool,
  Header: PropTypes.func
}

const initialvalues = {
  templateData: [],
  boxes: [],
}

// 1227: ResponseDetails page
const ResponseList = (props) => {
  const location = useLocation()
  const requestId = location.pathname.split('/')[3]
  const { initialResp } = props
  // eslint-disable-next-line
  const [state, setState, getState] = useMergeState(initialvalues)
  const [isLoading, setIsLoading] = useState(false)
  const defaultBox = state?.boxes?.find((box) => box?.value === 'ALL')
  const defOption = initialResp !== undefined ? initialResp : defaultBox
  const defResponse = initialResp !== undefined ? [initialResp] : [defaultBox]
  const [defaultResp, setDefaultResp] = useState(defResponse)
  const [selectedBoxValue, setSelectedBoxValue] = useState(null)
  // const [selectedRespValue, setSelectedRespValue] = useState(null)
  // const [actId, setActId] = useState('')
  const [responseData, setData] = React.useState([])

  const { t } = useTranslation()

  // const respOptions = [
  //   { value: 'all', label: 'All' },
  //   { value: 'format', label: 'Format Error' },
  // ]

  // 1227: To fetch the boxes which are is Published and isProcessed
  useEffect(async () => {
    getStdTemplateFields()
  }, [requestId])

  // 1227: function to fetch the Response details for a particular box on dropdown selection
  const handleBoxIdChange = async (event, selectedBox) => {
    try {
      setIsLoading(true)
      const boxValue = defaultResp?.length > 0 ? (initialResp?.activityId || defOption?.value) : selectedBox?.value
      const respBoxValue = state?.boxes?.find((box) => box?.value === boxValue)
      setSelectedBoxValue(respBoxValue || null)
      if (!boxValue) {
        setData([])
        return
      }
      let collection
      if (boxValue === 'ALL') {
        collection = await localGdeTransactions.getSelectedResponse(requestId, true)
      } else {
        collection = await localGdeTransactions.getSelectedResponse(boxValue, false)
      }

      const constructUserFields = (imageDocs) => {
        return imageDocs.flatMap((box) => {
          if (!box.idpResponse) {
            return []
          }
          if (!box.formatError) {
            return []
          }
          const processFields = (fields, folder, isLocked = false) => {
            return Object.entries(fields).reduce((result, [fieldName, fieldData]) => {
              const { fieldId } = fieldData
              if (box.idpResponse[folder]) {
                result[fieldId] = isLocked
                  ? fieldData.lockedValue
                  : box.idpResponse[folder][fieldName] || ''

                const error = box?.formatErrorInfo?.[folder]?.[fieldName]
                if (error) {
                  result.errors = { ...result.errors, [fieldId]: error }
                }
                result.boxId = box.skpBoxNbr
              }
              return result
            }, {})
          }

          return Object.keys(box.idpResponse)
            .sort()
            .map((folder) => {
              const userFields1 = processFields(box?.template, folder)
              const userFields2 = processFields(box?.templateLocked, folder, true)
              return { ...userFields1, ...userFields2 }
            })
        })
      }

      const extractedFields = constructUserFields(collection)
      setData(extractedFields)
      setDefaultResp([])
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error processing dropdown change:', error)
    } finally {
      setIsLoading(false)
    }
  }

  // 1227: function To fetch the boxes which are is Published and isProcessed & to get the templatefields
  const getStdTemplateFields = async () => {
    const requestData = await localGdeTransactionLite.getRequestById(requestId)
    const templateDatano = Object.values(requestData?.template).map(item => item.fieldId)
    let templateDatalo = []
    if (requestData?.templateLocked) {
      templateDatalo = Object.values(requestData?.templateLocked).map(item => item.fieldId)
    }
    const templateData = [...templateDatano, ...templateDatalo]
    // const templateName = requestData?.templateName
    // const templateDataRaw = await localGdeTransactions.getTemplateById(templateName)
    // const templateDataObj = templateDataRaw.data().templateFields
    // delete templateDataObj.skpBoxId
    // delete templateDataObj.customerId
    // const objKeys = Object.keys(templateDataObj)
    // const templateData = objKeys.sort((a, b) => {
    //   return templateDataObj[a].order - templateDataObj[b].order
    // })
    templateData.unshift('boxId')
    const boxDetails = await localGdeTransactionLite.getSubActivity(requestId)
    let boxes = []
    boxDetails.docs.forEach((doc) => {
      const boxData = doc?.data()
      if (boxData?.isProcessed && boxData?.isPublished && !boxData?.isIdpFail && boxData?.formatError) {
        boxes.push({
          value: doc?.id,
          label: boxData?.skpBoxNbr.trim(),
        })
      }
    })
    if (boxes.length >= 1) {
      boxes.unshift({
        value: 'ALL',
        label: 'All Boxes',
      })
    }
    boxes = Array.from(
      new Set(boxes.map((item) => JSON.stringify(item)))
    ).map((item) => JSON.parse(item))
    setState({
      templateData: templateData,
      boxes: boxes
    })
  }
  // 1227: To bydefault set the dropdowns & column data when user clicks on true in BoxDetails screen
  useEffect(() => {
    if ((state?.boxes?.length > 0) && (initialResp?.boxId || defOption?.value)) {
      handleBoxIdChange()
      // handleResponseChange()
    }
  }, [state?.boxes, initialResp])

  let columnsResponse = []
  // 1227: Defining the preExisted Columns from template Data
  columnsResponse = [
    ...state.templateData.map((item) => ({
      header: item,
      accessorKey: item,
      Cell: ({ cell, row }) => {
        const fieldName = item
        const errors = row.original.errors || {}
        return (
          <div>
            <span>
              {cell.getValue()}
            </span>
            {errors[fieldName] && (
              <div style={{ color: 'red', fontSize: '0.8em' }}>
                {errors[fieldName]}
              </div>
            )}
          </div>
        )
      }
    }))
  ]

  columnsResponse = columnsResponse.map((col) => {
    const headerLength = col.header.length
    let minWidth = 0
    if (headerLength < 8) {
      minWidth = headerLength * 8
    } else {
      minWidth = headerLength * 15
    }
    return {
      ...col,
      minSize: minWidth,
      muiTableHeadCellProps: {
        sx: {
          whiteSpace: 'nowrap',
          wordWrap: 'break-word',
          minWidth: `${minWidth}px`,
          overflow: 'visible',
          color: '#58595B',
          fontWeight: 'bold',
        },
      },
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        }
      },
    }
  })

  const columnsResponseErr = columnsResponse.filter((col) =>
    responseData.some((row) => {
      const hasdata = row[col.accessorKey] !== '' && row[col.accessorKey] !== undefined && row[col.accessorKey] !== null
      const hasError = row.errors?.[col.accessorKey] && row.errors[col.accessorKey] !== ''
      return hasdata || hasError
    })
  )
  const responseDataErr = responseData.filter((row) =>
    row.errors !== undefined
  )

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.smartCatalogRequest'
      subTitle={<><GoBackSubtitle id={'boxList_goBack'}
      /><DetailsSubtitle
        onShowBoxList={props.onShowBoxList}
        responseColor={props.responseColor} onShowResponseList={props.onShowResponseList}/></>}
    >
      {props?.Header()}
      <XDivider width='18px' />
      <Box boxShadow={2} borderRadius={4}>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '22px' }}>
          <Typography variant="h6" gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
            {t('routeTitles.responseDetails')}
          </Typography>
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          <Autocomplete
            sx={{ m: 1, width: '15%' }}
            size="small"
            label={t('tableColumns.boxId')}
            options={state.boxes}
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={selectedBoxValue}
            onChange={handleBoxIdChange}
            renderInput={(params) => (
              <TextField {...params} label={t('tableColumns.boxId')} variant="outlined" />
            )}
            noTranslate />
          {/* <Autocomplete
            sx={{ m: 1, width: '15%' }}
            size="small"
            label={t('tableColumns.responseType')}
            options={respOptions}
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={selectedRespValue}
            onChange={handleResponseChange}
            renderInput={(params) => (
              <TextField {...params} label={t('tableColumns.responseType')} variant="outlined" />
            )}
            noTranslate /> */}
        </div>
        <MaterialReactTable
          columns={columnsResponseErr}
          data={responseDataErr}
          enableColumnFilters={true}
          enableRowSelection
          state={{ showSkeletons: isLoading }}
          enableExport={true}
          enableGlobalFilter
          enableColumnFilter
          enableColumnSorting
          enableGrouping={true}
          enableColumnResizing={true}
          muiTableHeadCellProps={{
            sx: {
              color: '#58595B',
              fontWeight: 'bold',
              // flexGrow: 1
            },
          }}
          initialState={{
            sorting: [
              {
                id: 'boxId',
                desc: false,
              },
            ],
            density: 'compact'
          }}
          renderTopToolbarCustomActions={({ table, data }) => {
            const isDisabled = !table.getIsSomeRowsSelected()
            const isNoData = responseDataErr?.length === 0
            const isNoPageData = responseDataErr?.length > 4
            return (
              <ExportCsv
                columns={columnsResponseErr}
                isDisabled={isDisabled}
                isNoData={isNoData}
                isNoPageData={isNoPageData}
                table={table}
              />
            )
          }}
          tableFor={'smart_catalog'}
        />
      </Box>
    </MainRouteSubRoutePage>
  )
}

ResponseList.propTypes = {
  onShowBoxList: PropTypes.func,
  onShowResponseList: PropTypes.func,
  responseColor: PropTypes.bool,
  Header: PropTypes.func
}

const LocalActivityDetails = props => {
  const [showTable, setShowTable] = useState('boxDetails')
  const [boxColor, setBoxColor] = useState(true)
  const [responseColor, setResponseColor] = useState(true)
  const [initialResp, setInitialResp] = useState(undefined)
  const classes = useStyles()
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const [requestData, setRequestData] = useState([])
  const requestId = location.pathname.split('/')[3]
  const [RequestDetails, setRequestDetails] = useState({})
  const [isEditing, setIsEditing] = useState(false)
  const [customName, setCustomName] = useState('')
  const [isBusy, setBusy] = useState(false)
  const isMountedRef = useRef(true)

  // Track component mount status
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const requestDetails = [
    { label: t('demo.requestId'), value: getState()?.requestData?.id },
    { label: t('tableColumns.customRequestName'), value: getState()?.requestData.customRequestName },
    // { label: t('templates.customTemplateName'), value: getState()?.requestData.customTemplateName },
    { label: t('Search.wms'), value: getState()?.requestData.wmsCode },
    { label: t('smartCatalog.orderId'), value: getState()?.requestData?.orderId },
    { label: t('app.district'), value: getState()?.requestData?.districtName },
    { label: t('Search.Customer'), value: getState()?.requestData?.custName },
  ]

  useEffect(() => {
    let unsubscribe = null
    
    // Wrap setRequestData to check mount status
    const safeSetRequestData = (data) => {
      if (isMountedRef.current) {
        setRequestData(data)
      }
    }
    
    const setupListener = async () => {
      if (!isMountedRef.current) return
      getRequestDetails()
      unsubscribe = await localGdeTransactions.countListner(safeSetRequestData, requestId)
    }
    
    setupListener()
    
    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [requestId])

  useEffect(() => {
    if (!isMountedRef.current) return
    getRequestDetails()
  }, [requestData])
  

  const calculatePercentage = (count, total) => {
    if (total === 0) {
      return 0
    } else {
      return Math.round((count / total) * 100)
    }
  }

  const getRequestDetails = async () => {
    if (!isMountedRef.current) return
    
    try {
      let requestDetails = {}
      setBusy()
      if (requestData.length === 0) {
        const requestData = await localGdeTransactionLite.getRequestById(requestId)
        requestDetails = {
          id: requestData?.requestId,
          customRequestName: requestData?.customRequestName,
          // customTemplateName: requestData?.customTemplateName,
          custId: requestData?.accountLevel1,
          building: requestData?.building,
          orderId: requestData?.orderId,
          districtName: requestData?.district,
          templateName: requestData?.templateName,
          custName: requestData?.accountLevel1,
          status: requestData?.status,
          statusCount: requestData?.statusCount,
          boxCount: requestData?.boxCount,
          wmsCode: requestData?.wmsCode
        }
      } else {
        requestDetails = {
          id: requestData[0]?.requestId,
          customRequestName: requestData[0]?.customRequestName,
          // customTemplateName: requestData[0]?.customTemplateName,
          custId: requestData[0]?.accountLevel1,
          building: requestData[0]?.building,
          orderId: requestData[0]?.orderId,
          districtName: requestData[0]?.district,
          templateName: requestData[0]?.templateName,
          custName: requestData[0]?.accountLevel1,
          status: requestData[0]?.status,
          statusCount: requestData[0]?.statusCount,
          boxCount: requestData[0]?.boxCount,
          wmsCode: requestData[0]?.wmsCode
        }
      }
      if (isMountedRef.current) {
        setState({ requestData: requestDetails, status: requestDetails?.status, wmsCode: requestDetails?.wmsCode })
      }
      if (requestDetails?.statusCount) {
        // eslint-disable-next-line
        const { completed, exception, idpException, uploaded, wmsUploaded, wmsPending } = requestDetails?.statusCount
        const totalBoxes = requestDetails?.boxCount || 0
        setState({ closedCount: completed ?? 0, uploadedCount: uploaded ?? 0, exceptionCount: idpException || 0, totalBoxes: totalBoxes, oneilBoxesUploaded: wmsUploaded || 0, oneilBoxesPending: wmsPending || 0 })
      }
  
      setRequestDetails(requestDetails)
      setCustomName(requestDetails.customRequestName) // Set initial custom name
      // setState({ requestData: requestDetails })
      clearBusy()
    } catch (error) {
      console.error('Error fetching request details:', error)
    }
  }

  const handleEditClick = () => {
    setCustomName(RequestDetails.customRequestName) // Set to current value
    setIsEditing(true)
  }

  // Handle save click
  const handleSaveClick = async () => {
    setBusy(true)
    // setIsEditing(true)
    
    try {
      // await saveCustomName(customName, RequestDetails.id) 
      const updatedData = { customRequestName: customName }
      await localGdeTransactionLite.updateRequestDetails(RequestDetails.id, updatedData)
      await getRequestDetails() // Refetch request details
      setIsEditing(false)
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error saving custom request name:', error)
    } finally {
      setBusy(false)
    }
  }

  const Header = () => {
    return (
      <Box className={classes.containerGroup}>
        <Container className={classes.container}>
          {requestDetails.map((detail) => (
            // detail.value &&
            <Typography
              component="div"
              variant="body1"
              className={classes.content}
              key={detail.label}
            >
              <span className={classes.label}>{detail.label}: </span>
              {(detail.label === t('tableColumns.customRequestName'))
                ? (
                  <>
                    {isEditing
                      ? (
                        <TextField
                          value={customName}
                          onChange={(e) => setCustomName(e.target.value)}
                          // variant="contained"
                          size="small"
                          className={classes.editableInput}
                          onClick={handleEditClick}

                        />
                        )
                      : (
                        <span className={classes.value}>
                          {RequestDetails.customRequestName}
                        </span>
                        )}

                    {
                      isEditing
                        ? (
                          <Button
                            onClick={handleSaveClick}
                            variant="contained"
                            color="primary"
                            size="small"
                            // startIcon={<SaveIcon />}
                            disabled={isBusy}
                            style={{ margin: '0 0 0 4px' }}
                          >
                            Save
                          </Button>
                          )
                        : (
                          <IconButton onClick={handleEditClick} disabled={isBusy} color="primary">
                            <EditIcon />

                          </IconButton>
                          )}
                  </>
                  )
                : (
                  <span className={classes.value}>{detail.value}</span>
                  )}
            </Typography>

          ))}
          <Typography component="div" variant="body1" className={classes.content}>
            <span className={classes.label}>{`${t('smartCatalog.status')} `}</span>
            <span className={classes.value}>{`${getState()?.status}`.charAt(0).toUpperCase() + getState()?.status?.slice(1)} </span>
          </Typography>
        </Container>
        <Box className={classes.progressContainer}>
          <Container className={classes.ProgressBox}>
            <Typography component="div" variant="body1" className={classes.contentBox}>{`${t('tableColumns.boxesCompleted')} `}</Typography>
            <Typography component="div" variant="body1" className={classes.contentBox}>{`${getState()?.closedCount} / ${getState()?.totalBoxes}`}</Typography>
            <Box className={classes.progressBarContainer}>
              <LinearProgress
                variant="determinate"
                value={calculatePercentage(getState()?.closedCount, getState()?.totalBoxes)}
                className={classes.progressBar}
                sx={Styles.progressBarStyle}
              />
              <Typography variant="body1" className={classes.contentBox}>
                {calculatePercentage(getState()?.closedCount, getState()?.totalBoxes)}%
              </Typography>
            </Box>
          </Container>
          <Container className={classes.ProgressBox}>
            <Typography variant="body1" className={classes.contentBox}>{`${t('jobStatusObj.uploaded')}`}</Typography>
            <Typography variant="body1" className={classes.contentBox}>{`${getState()?.uploadedCount} / ${getState()?.totalBoxes}`}</Typography>
            <Box className={classes.progressBarContainer}>
              <LinearProgress
                variant="determinate"
                value={calculatePercentage(getState()?.uploadedCount, getState()?.totalBoxes)}
                className={classes.progressBar} sx={Styles.progressBarStyle}
              />
              <Typography variant="body1" className={classes.contentBox}>
                {calculatePercentage(getState()?.uploadedCount, getState()?.totalBoxes)}%
              </Typography>
            </Box>
          </Container>
          <Container className={classes.ProgressBox}>
            <Typography variant="body1" className={classes.contentBox}>{`${t('smartCatalog.oneilBoxesUploaded')} `}</Typography>
            <Typography variant="body1" className={classes.contentBox}>{`${getState()?.oneilBoxesUploaded} / ${getState()?.totalBoxes}`}</Typography>
            <Box className={classes.progressBarContainer}>
              <LinearProgress
                variant="determinate"
                value={calculatePercentage(getState()?.oneilBoxesUploaded, getState()?.totalBoxes)}
                className={classes.progressBar} sx={Styles.progressBarStyle}
              />
              <Typography variant="body1" className={classes.contentBox}>
                {calculatePercentage(getState()?.oneilBoxesUploaded, getState()?.totalBoxes)}%
              </Typography>
            </Box>
          </Container>
          <Container className={classes.ProgressBox}>
            <Typography variant="body1" className={classes.contentBox}>{`${t('smartCatalog.oneilBoxesPending')}`}</Typography>
            <Typography variant="body1" className={classes.contentBox}>{`${getState()?.oneilBoxesPending} / ${getState()?.totalBoxes}`}</Typography>
            <Box className={classes.progressBarContainer}>
              <LinearProgress
                variant="determinate"
                value={calculatePercentage(getState()?.oneilBoxesPending, getState()?.totalBoxes)}
                className={classes.progressBar} sx={Styles.progressBarStyle}
              />
              <Typography variant="body1" className={classes.contentBox}>
                {calculatePercentage(getState()?.oneilBoxesPending, getState()?.totalBoxes)}%
              </Typography>
            </Box>
          </Container>
          <Container className={classes.ProgressBox}>
            <Typography variant="body1" className={classes.contentBox}>{`${t('smartCatalog.exceptions')}`}</Typography>
            <Typography variant="body1" className={classes.contentBox}>{getState()?.exceptionCount}</Typography>
            <Box className={classes.progressBarContainer}>
              <LinearProgress
                variant="determinate"
                value={calculatePercentage(getState()?.exceptionCount, getState()?.totalBoxes)}
                className={classes.progressBar}
                sx={Styles.progressBarStyle}
              />
              <Typography variant="body1" className={classes.contentBox}>
                {calculatePercentage(getState()?.exceptionCount, getState()?.totalBoxes)}%
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>
    )
  }

  const onHandleFormatError = (rowData) => {
    setInitialResp(rowData)
    setShowTable('responseDetails')
    setResponseColor(true)
  }

  const ButtonsForTemplateAssign = props =>
    <>
      <CancelButton id={'addBoxTransmittal_button_cancel'} onClick={props.handleCancel} />
      <XDivider width='10px' />
    </>

  const showRequestList = async (rowData) => {
    let constructUserFields
    const imageDocs = await localGdeTransactionLite.getwmsResponse(rowData.activityId)
    imageDocs.forEach(item => {
      const lineItems = getState().wmsCode === 'SKP' ? item.response?.response?.lineitems : item.response?.response?.lineItems
      if (Array.isArray(lineItems)) {
        lineItems.forEach((lineItem, index) => {
          if ('error' in lineItem) {
            // eslint-disable-next-line
            console.log(`Error ${index}: ${lineItem.error}`)
          }
        })
      }
    })

    if (getState().wmsCode === 'ONEIL') {
      constructUserFields = (imageDocs) => {
        if (!imageDocs || imageDocs.length === 0) return []

        // Find the object with the latest createdTs
        const latestObj = imageDocs.reduce((latest, current) => {
          return new Date(current.createdTs) > new Date(latest.createdTs) ? current : latest
        }, imageDocs[0])

        const lineItems = latestObj?.response?.response?.lineItems || []


        const errorItemsWithIndex = lineItems
          .map((item, index) => ({ item, index }))
          .filter(({ item }) => 'error' in item)

        // Define columns
        const columnsResponse = [
          {
            header: ' Flat File Record Sequence',
            accessorKey: 'srNo',
            Cell: ({ row }) => row.original.srNo,
            minSize: 260,
            muiTableHeadCellProps: {
              sx: {
                whiteSpace: 'nowrap',
                minWidth: '150px',
                fontWeight: 'bold',
                color: '#58595B',
              },
            },
            muiTableBodyCellProps: {
              sx: {
                whiteSpace: 'nowrap',
                textAlign: 'center',
              },
            },
          },
          {
            header: 'WMS Error',
            accessorKey: 'errorMsg',
            Cell: ({ cell }) => (
              <div style={{ color: 'red', fontSize: '0.8em' }}>
                {cell.getValue()}
              </div>
            ),
            minSize: 200,
            muiTableHeadCellProps: {
              sx: {
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
                minWidth: '200px',
                overflow: 'visible',
                color: '#58595B',
                fontWeight: 'bold',
              },
            },
            muiTableBodyCellProps: {
              sx: {
                whiteSpace: 'normal',
                // wordWrap: 'break-word',
                // wordBreak: 'break-word',
                // overflowWrap: 'break-word',
                width: 'auto'
              },
            },
          },
        ]

        setState({ columnsNew: columnsResponse })

        return errorItemsWithIndex.map(({ item, index }) => ({
          srNo: index + 1,
          errorMsg: item.error,
          errors: { errorMsg: item.error },
        }))
      }
    } else {
      constructUserFields = (imageDocs) => {
        if (!imageDocs || imageDocs.length === 0) return []

        const latestObj = imageDocs.reduce((latest, current) => {
          return new Date(current.createdTs) > new Date(latest.createdTs) ? current : latest
        }, imageDocs[0])

        const lineItems = latestObj?.response?.response?.lineitems || []

        const failedItemsWithIndex = lineItems
          .map((item, index) => ({ item, index }))
          .filter(({ item }) => item.Status === 'FAIL')

        const columnsResponse = [
          {
            header: ' Flat File Record Sequence',
            accessorKey: 'srNo',
            Cell: ({ row }) => row.original.srNo,
            minSize: 260,
            muiTableHeadCellProps: {
              sx: {
                whiteSpace: 'nowrap',
                minWidth: '150px',
                fontWeight: 'bold',
                color: '#58595B',
              },
            },
            muiTableBodyCellProps: {
              sx: {
                whiteSpace: 'nowrap',
                textAlign: 'center',
              },
            },
          },
          {
            header: 'WMS Exception',
            accessorKey: 'exceptionMsg',
            Cell: ({ cell }) => (
              <div style={{ color: 'red', fontSize: '0.8em' }}>
                {cell.getValue()}
              </div>
            ),
            minSize: 200,
            muiTableHeadCellProps: {
              sx: {
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
                minWidth: '200px',
                overflow: 'visible',
                color: '#58595B',
                fontWeight: 'bold',
              },
            },
            muiTableBodyCellProps: {
              sx: {
                whiteSpace: 'normal',
                width: 'auto'
              },
            },
          },
        ]

        setState({ columnsNew: columnsResponse })

        return failedItemsWithIndex.map(({ item, index }) => ({
          srNo: index + 1,
          exceptionMsg: item.ExceptionDesc,
          errors: { exceptionMsg: item.ExceptionDesc },
        }))
      }
    }

    const responseData = constructUserFields(imageDocs)
    // const columns = getState()?.columnsNew || []
    const handleCancel = () => {
      closeGeneralDialog()
    }

    openGeneralDialog({
      title: t('routeTitles.wmsResponseDetails'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <LocalShowWmsResponseModal columns={getState()?.columnsNew} data={responseData} />,
      buttons: <ButtonsForTemplateAssign handleCancel={handleCancel} />,
      closeX: true
    })
  }

  const onShowBoxList = () => {
    setInitialResp(undefined)
    setShowTable('boxDetails')
    setBoxColor(true)
  }

  const onShowResponseList = () => {
    setShowTable('responseDetails')
    setResponseColor(true)
  }

  if (showTable === 'boxDetails') {
    return (
      <BoxSubList onHandleFormatError={onHandleFormatError} Header={Header} boxColor={boxColor} onShowBoxList={onShowBoxList} onShowResponseList={onShowResponseList} onShowRequestList={showRequestList}/>
    )
  } else if (showTable === 'responseDetails') {
    return (
      <ResponseList initialResp={initialResp} Header={Header} responseColor={responseColor} onShowResponseList={onShowResponseList} onShowBoxList={onShowBoxList} />
    )
  }
}

export default LocalActivityDetails
